import { defaultFilter } from '@fabric-ui/components/Table';
import { schema } from '@Schema/schema';
import { withDefaults } from '@Schema/utils';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { PAGE_PATHS } from '../../../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/settings/permissions/content-permissions/edit-users/$id/')({
  validateSearch: zodValidator(withDefaults(schema.CONTENT_PERMISSIONS, defaultFilter)),
  beforeLoad: ({ context, preload }) => {
    const isAllowed = context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.CONTENT_PERMISSIONS });
    context.validatePermissions({ isAllowed, preload });
  },
});
